exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transition-list[data-v-3a49ede9] {\n  width: 100% !important;\n}\n.profile-image-round[data-v-3a49ede9] {\n  min-width: 3rem;\n  max-width: 3rem;\n  min-height: 3rem;\n  max-height: 3rem;\n  border-radius: 50%;\n}", ""]);

// exports
